import { Platform } from "@src/mobile/utils/platform";
import { signInWithRedirect } from "aws-amplify/auth";

import { APP_V2_APP_EVENTS, logEvent } from "../../lib/analytics";
import { setActiveSsoProvider, SSO_PROVIDER } from "../Sso/activeProvider";

const OKTA_COGNITO_IDP_NAME = "OktaEmployees";

interface StartOktaSsoRedirectOptions {
  source?: string;
}

export async function startSsoRedirect(
  _requestedUrl?: string,
  options?: StartOktaSsoRedirectOptions
): Promise<void> {
  logEvent(APP_V2_APP_EVENTS.OKTA_SSO_STARTED, { source: options?.source });

  if (Platform.isMobile) {
    throw new Error("Okta SSO is not supported on Capacitor yet");
  }

  setActiveSsoProvider(SSO_PROVIDER.OKTA);

  await signInWithRedirect({
    provider: { custom: OKTA_COGNITO_IDP_NAME },
    options: { prompt: "LOGIN" },
  });
}
